import styles from "@website/ui/badge/badge.module.scss";
import { BadgePropertiesType } from "@website/ui/badge/badge.types";
import { FC, memo } from "react";

const Badge: FC<BadgePropertiesType> = (properties) => {
  const { content, color, className } = properties;

  return (
    <span
      className={`${styles["container"]} ${styles[color || "primary"]} ${
        content ? styles["fill"] : ""
      } ${className ?? ""}`}
    >
      {content}
    </span>
  );
};

const BadgeMemoized = memo(Badge);
export { BadgeMemoized as Badge };
